<div class="col gap-16 w100">
    <div class="row space-between w100">
        <img src="/images/default-agent.png" alt="" />
        <rr-icon
            name="close"
            class="pointer"
            (click)="dialogRef.close()"
        ></rr-icon>
    </div>
    <div class="col gap-4 w100">
        <div class="uppercase-label">Hello there I'm Johnny!</div>
        <h2>Congratulations, little<br />Inno-Hero 🎉</h2>
        <div></div>
        <div>
            You have successfully completed the first part of your idea journey.
        </div>
    </div>
</div>
<img src="/images/jhonny-gratulations.png" alt="" />
<div>What's next:</div>
<div class="nextsteps gap-16 col">
    <div class="row gap-8" *ngFor="let step of nextSteps">
        <rr-icon name="arrow-right" class="w24"></rr-icon>
        <div class="col gap-4">
            <h4 class="strong">{{ step.title }}</h4>
            <div>{{ step.description }}</div>
        </div>
    </div>
</div>
<div class="row w100 align-end justify-end">
    <rr-btn type="Primary" size="Medium" iconEnd="arrow-right" (click)="close()"
        >Proceed</rr-btn
    >
</div>
